import { RedirectService } from './services/redirect.services';
import { LeftSidebarLayoutComponent } from './containers/left-sidebar-layout/left-sidebar-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
  NoSidebarLayoutComponent
} from './containers';
import { MenuModule } from './views/menus/menu.module';

export const routes: Routes = [
  {
    path: '',
    component: NoSidebarLayoutComponent,
    canActivate: [RedirectService],
    pathMatch: 'full',
  },
  {
    path: '',
    component: NoSidebarLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      }
    ]
  },
  {
    path: 'order',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Order'
    },
    children: [
      {
        path: '',
        loadChildren: './views/order/order.module#OrderModule',
      }
    ]
  },
  {
    path: 'po',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'PO'
    },
    children: [
      {
        path: '',
        loadChildren: './views/purchase/po.module#POModule',
      }
    ]
  }
  ,
  {
    path: 'so',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'SO'
    },
    children: [
      {
        path: '',
        loadChildren: './views/saleorder/so.module#SOModule',
      }
    ]
  },
  {
    path: 'report',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Report'
    },
    children: [
      {
        path: '',
        loadChildren: './views/report/report.module#ReportModule',
      }
    ]
  }
  ,
  {
    path: 'payment',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Payment'
    },
    children: [
      {
        path: '',
        loadChildren: './views/payment/payment.module#PaymentModule',
      }
    ]
  },
  {
    path: 'paymentbank',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Payment Bank'
    },
    children: [
      {
        path: '',
        loadChildren: './views/paymentbank/bank.module#PaymentBankModule',
      }
    ]
  },
  {
    path: 'customer',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Customer'
    },
    children: [
      {
        path: '',
        loadChildren: './views/customer/customer.module#CustomerModule',
      }
    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  },
  {
    path: 'menu',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Menu'
    },
    children: [
      {
        path: '',
        loadChildren: './views/menus/menu.module#MenuModule',
      }
    ]
  }
  ,
  {
    path: 'test',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Test'
    },
    children: [
      {
        path: '',
        loadChildren: './views/testcomponent/test.module#TestModule',
      }
    ]
  },
  {
    path: 'backtomerchant',
    component: NoSidebarLayoutComponent,
    data: {
      title: 'Back To Merchant'
    },
    children: [
      {
        path: '',
        loadChildren: './views/backtomerchant/back-to-merchant.module#BackToMerchantModule',
      }
    ]
  },
  {
    path: 'transaction',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Bank Transaction'
    },
    children: [
      {
        path: '',
        loadChildren: './views/banktransaction/bank-transaction.module#BankTransactionModule',
      }
    ]
  },
  {
    path: 'promotion',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Promotion'
    },
    children: [
      {
        path: '',
        loadChildren: './views/promotion/promotion.module#PromotionModule',
      }
    ]
  },
  {
    path: 'setting',
    component: LeftSidebarLayoutComponent,
    data: {
      title: 'Setting'
    },
    children: [
      {
        path: '',
        loadChildren: './views/setting/setting.module#SettingModule',
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts